import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { saveAs } from 'file-saver';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { Subscription } from 'rxjs';
import { Attachment } from '../../shared/components/attachments/attachment-service/models/attachment-model';
import { nullSafePath } from '../../shared/helpers/null-safe-path';
import * as ClassicEditor from '../../vendors/ckeditor5/ckeditor';
import { ApplicantMessageService } from './applicant-message.service';
import { Message } from './models/message';

@Component({
  selector: 'app-applicant-message',
  templateUrl: './applicant-message.component.html',
  styleUrls: ['./applicant-message.component.scss']
})
export class ApplicantMessageComponent implements OnInit, OnDestroy, AfterViewInit {
  public Editor = ClassicEditor;

  private readonly subscription = new Subscription();
  private jobId: number;
  private applicantFileId: number;
  private messageId: number;
  @ViewChild('thankYouModal') thankYouModal: ModalDirective;
  model: Message;
  reply = new Message();
  editorConfig: {} = {
    toolbar: ['bold', 'italic', 'underline', '|', 'numberedList', 'bulletedList', '|', 'link']
  };
  supportedFileTypes = [
    '.doc',
    '.docx',
    '.pdf',
    '.rtf',
    '.txt',
    '.xls',
    '.xlsx',
    '.jpg',
    '.jpeg',
    '.png',
    '.gif',
    '.tif'];
  maxFileSize = 5242880;
  maxCumulativeFileSize = 5242880 * 4;
  saveAttachmentRoute: string;
  messageSent: boolean;
  identifier: string;
  subBrandIdentifier: string;
  isProcessing = false;
  
  constructor(
    private readonly route: ActivatedRoute,
    private router: Router,
    private readonly messageService: ApplicantMessageService,
    private readonly toast: ToastService) { }

  ngOnInit() {
    this.subscription.add(
      this.route.data.subscribe(
        (data: { model: Message }) => {
          this.model = Object.assign(new Message(), data.model);
          this.reply = this.model.createReply();
        })
    );
    this.subscription.add(
      this.route.paramMap.subscribe(params => {
        this.identifier = params.get('identifier');
        this.subBrandIdentifier = params.get('subBrandIdentifier');
        this.jobId = +params.get('jobId');
        this.applicantFileId = +params.get('applicantFileId');
        this.messageId = +params.get('messageId');
        this.saveAttachmentRoute = `jobs/${this.jobId}/applicant-files/${this.applicantFileId}/messages/attachments`;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngAfterViewInit(): void {
    if (this.model.hasReply) {
      this.thankYouModal.show();
    }
  }

  downloadAttachment(attachment: Attachment) {
    this.subscription.add(
      this.messageService.downloadAttachment(this.jobId, this.applicantFileId, this.messageId, attachment)
        .subscribe(response => {
          saveAs(new Blob([response]), attachment.name);
        }));
  }

  submitReply() {
    this.isProcessing = true;
    this.messageService.submitReply(this.jobId, this.applicantFileId, this.messageId, this.reply)
      .subscribe(
        data => {
          this.isProcessing = false;
          this.messageSent = true;
          this.router.navigate(nullSafePath(
            this.identifier, this.subBrandIdentifier,
            'jobs', this.jobId,
            'applicants', this.applicantFileId,
            'messages', this.messageId, 'thank-you'
          ));
        },
        error => {
          this.isProcessing = false;
          this.toast.error('There was an error sending your message. Please try again later!', 'Error!');
        },
        () => {
          this.isProcessing = false;
        });
  }
}
